/**
 * @generated SignedSource<<160e18ec764146a5f63c5a20f3dffbae>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MainToolbar_data$data = {
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"UserArea_user">;
  } | null;
  readonly " $fragmentType": "MainToolbar_data";
};
export type MainToolbar_data$key = {
  readonly " $data"?: MainToolbar_data$data;
  readonly " $fragmentSpreads": FragmentRefs<"MainToolbar_data">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MainToolbar_data",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "viewer",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "UserArea_user"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "bc90bdcc5ff68c2f3d17f2b77f3874b9";

export default node;
